/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  device.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:26
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

// @ts-ignore
import enquireJs from "enquire.js";
import Fingerprint2 from "fingerprintjs2";
import { DEVICE_FINGERPRINT } from "@/constant/localstorage";

export const DEVICE_TYPE = {
  DESKTOP: "desktop",
  TABLET: "tablet",
  MOBILE: "mobile",
};

export async function getDeviceFingerprint() {
  const fingerprint = window.localStorage.getItem(DEVICE_FINGERPRINT);
  if (!fingerprint) {
    const components = await Fingerprint2.getPromise({});
    const values = components.map(function (component) {
      return component.value;
    });
    const murmur = Fingerprint2.x64hash128(values.join(""), 31);
    window.localStorage.setItem(DEVICE_FINGERPRINT, murmur);
    return murmur;
  }
  return fingerprint;
}

// 进入页面先执行一次，后面取的时候就可以取缓存了
getDeviceFingerprint();

export const deviceEnquire = function (callback: any) {
  const matchDesktop = {
    match: () => {
      callback && callback(DEVICE_TYPE.DESKTOP);
    },
  };

  const matchLablet = {
    match: () => {
      callback && callback(DEVICE_TYPE.TABLET);
    },
  };

  const matchMobile = {
    match: () => {
      callback && callback(DEVICE_TYPE.MOBILE);
    },
  };

  // screen and (max-width: 1087.99px)
  enquireJs
    .register("screen and (max-width: 576px)", matchMobile)
    .register(
      "screen and (min-width: 576px) and (max-width: 1199px)",
      matchLablet
    )
    .register("screen and (min-width: 1200px)", matchDesktop);
};
